// 全局的订阅者模式

import * as Rx from 'rxjs'

class Observer {
    public static subscribe(key: string, cb: (data: any) => void) {
        let subject: Rx.Subject<{}> | undefined = this.subjects.get(key)
        if (!subject) {
            subject = new Rx.Subject()
            this.subjects.set(key, subject)
        }
        const observable = Rx.Observable.create().subscribe({
            next: cb
        })
        subject.subscribe(observable)
    }

    public static unSubscribe(key: string) {
        const subject: Rx.Subject<{}> | undefined = this.subjects.get(key)
        if (subject) {
            subject.unsubscribe()
            this.subjects.delete(key)
        }
    }

    public static send(key: string, value?: any) {
        const subject: Rx.Subject<{}> | undefined = this.subjects.get(key)
        subject && subject.next(value)
    }

    private static subjects: Map<string, Rx.Subject<{}>> = new Map()
}

export {
    Observer
}


// WEBPACK FOOTER //
// ./src/utils/rx.ts